import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { FieldAutocomplete } from '@app/shared/models/field.interface';
import { fromEvent, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'vfs-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputSearchComponent implements AfterViewInit, OnDestroy {
  destroyed = new Subject();

  @Input() width = '100%';
  @Input() autocomplete: FieldAutocomplete = FieldAutocomplete.OFF;
  @Input() autofocus = false;
  @ViewChild('input') inputRef: ElementRef;
  @Output() change = new EventEmitter<string>();

  ngAfterViewInit() {
    fromEvent(this.inputRef.nativeElement, 'keyup')
      .pipe(
        takeUntil(this.destroyed),
        debounceTime(800),
        distinctUntilChanged(),
        tap(() => {
          this.change.emit(this.inputRef.nativeElement.value.replace(/\s+/g, ' ').trim());
        })
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed = null;
  }

  clear() {
    this.inputRef.nativeElement.value = '';
    this.change.emit(this.inputRef.nativeElement.value);
  }
}
